import React from 'react';

export default function ReporteIncidencias() {
  return (
    <div className="container-fluid">
      <h4 className="mb-3">Reportes • Trazabilidad de Incidencias</h4>
      <div className="card">
        <div className="card-body">
          Contenido de Trazabilidad de Incidencias (pendiente de implementar).
        </div>
      </div>
    </div>
  );
}

